import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Dropzone, Photo } from 'components';

import {
  activateDropzone,
  closePicker,
  deactivateDropzone,
  openPicker,
  setDragging,
  setNotification,
} from 'redux/reducers/app';
import { add as addPhotos } from 'redux/reducers/photos';

import cx from 'classnames';
import styles from './styles.scss';

const MAX_UPLOAD = 64 * 1000 * 1000;

@connect(
  state => ({
    dropzoneActive: state.getIn(['app', 'dropzone', 'active'], false),
    draggingPhoto: state.getIn(['app', 'isDragging'], false),
  }),
  {
    setDragging,
    activateDropzone,
    deactivateDropzone,
    addPhotos,
    openPicker,
    closePicker,
    setNotification,
  }
)
export default class Dragzone extends React.PureComponent {
  onDrop = (acceptedFiles, rejectedFiles) => {
    this.props.addPhotos(acceptedFiles);
    this.props.deactivateDropzone();

    if (acceptedFiles.length > 0) {
      this.props.openPicker();
    }

    if (rejectedFiles.length > 0) {
      if (rejectedFiles.length === 1) {
        this.props.setNotification('rejectedFiles', kroostApp.strings.photoDoesntUploadAlert);
        console.log(rejectedFiles);
      } else {
        this.props.setNotification(
          'rejectedFiles',
          kroostApp.strings.photoDoesntUploadAlertPlural.replace('{rejectedFiles}', rejectedFiles.length)
        );
      }
      setTimeout(() => {
        this.props.setNotification('rejectedFiles', null);
      }, 5000);
    }
  };

  onDragEnter = () => {
    if (!this.props.dropzoneActive) {
      this.props.activateDropzone();
    }
  };

  onDragLeave = () => {
    if (this.props.dropzoneActive) {
      this.props.deactivateDropzone();
    }
  };

  onPhotoDragLeave = e => {
    e = e ? e : window.event;
    const from = e.relatedTarget || e.toElement;
    if (!from || from.nodeName == 'HTML') {
      this.props.setDragging(false);
    }
  };

  onDragOver = e => {
    this.draggingPhoto.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
  };

  onMouseUp = () => {
    this.props.setDragging(false);
  };

  doNothing = () => {
    return false;
  };

  render() {
    const { dropzoneActive, draggingPhoto } = this.props;
    const classes = cx(styles.dropzone, {
      [styles.active]: dropzoneActive,
    });

    const dragzoneProps = {};
    if (draggingPhoto) {
      dragzoneProps.onMouseOut = this.onPhotoDragLeave;
      dragzoneProps.onMouseMove = this.onDragOver;
      dragzoneProps.onMouseUp = this.onMouseUp;
    }

    return (
      <Dropzone
        ref={c => (this.dropzone = c)}
        className={classes}
        onDragEnter={this.props.disabled ? this.doNothing : this.onDragEnter}
        onDragLeave={this.props.disabled ? this.doNothing : this.onDragLeave}
        onDrop={this.props.disabled ? this.doNothing : this.onDrop}
        maxSize={MAX_UPLOAD}
        accept="image/*">
        <div className={styles.message}>
          <span style={{ backgroundColor: 'red' }}>{kroostApp.strings.callToUseThePhotos}</span>
        </div>
        {draggingPhoto ? (
          <Photo
            ref={c => (this.draggingPhoto = ReactDOM.findDOMNode(c))}
            className={styles.draggingPhoto}
            photo={draggingPhoto}
          />
        ) : null}
        <div className={styles.dragzone} {...dragzoneProps}>
          {this.props.children}
        </div>
      </Dropzone>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/dragzone/index.js